import createApp from './app';
import Vue from 'vue';
import { HeaderAdsSsrRequest } from './types';
import { hydrateSsrRoots } from 'JS/ssr/client-utilities';

export function mountHeaderAds() {
	hydrateSsrRoots<HeaderAdsSsrRequest>("header-ads", (el, data) => {
		const app = createApp(data);
		new Vue({
			extends: app,
			el,
		});
	});
}